<template>
  <div>
    <div>
      <b-button
        v-if="canUserEdit"
        variant="success"
        @click="OpenModal"
      >
        Erfassen
      </b-button>
    </div>
    <b-modal
      id="addNewWageSupplementConfiguration"
      ref="addNewWageSupplementConfiguration"
      class="w-100"
      hide-footer
      no-fade
      scrollable
      size="lg"
      title="Neue Gruppierung hinzufügen"
    >
      <u-error-handling
        v-if="errorObject"
        :error-object="errorObject"
      />
      <div class="d-block mb-4">
        Bestimmen sie einen Titel für die Gruppierung sowie die benötigten
        Übersetzungen. Wählen sie die Kriterienwerte, für die die
        Zuschlagsdefinition gelten soll. Wählen sie zuerst das Kriterium, danach
        die Listeneinträge.
      </div>
      <div class="row">
        <h5 class="col-4 mt-4">
          Titel
        </h5>
        <v-text-field
          :rules="[rules.required]"
          :value="wageSupplementTitle"
          class="col-7 ml-4"
          @change="ChangeWageSupplementTitle"
        />
      </div>
      <div
        v-if="languages.some((x) => x.language == 'de-CH')"
        class="row"
      >
        <div class="col-4" />
        <v-text-field
          v-model="wageSupplementContentDe"
          :rules="[rules.required]"
          class="col-7 ml-4"
          placeholder="Deutsch"
        />
      </div>
      <div
        v-if="languages.some((x) => x.language == 'fr-CH')"
        class="row"
      >
        <div class="col-4" />
        <v-text-field
          v-model="wageSupplementContentFr"
          :rules="[rules.required]"
          class="col-7 ml-4"
          placeholder="Französisch"
        />
      </div>
      <div
        v-if="languages.some((x) => x.language == 'it-CH')"
        class="row"
      >
        <div class="col-4" />
        <v-text-field
          v-model="wageSupplementContentIt"
          :rules="[rules.required]"
          class="col-7 ml-4"
          placeholder="Italienisch"
        />
      </div>
      <div class="row">
        <h5 class="col-4 mt-4">
          Kriterium
        </h5>
        <v-select
          v-model="selectedCriteria"
          :items="criteriaOptions"
          class="col-7 ml-4"
          item-text="title"
          item-value="id"
          return-object
          @change="LoadOptionOfCriteria"
        />
      </div>

      <div class="row">
        <h5 class="col-4 mt-4">
          Listeneinträge
        </h5>
        <v-select
          :items="criteriaEntryOptions"
          :value="selectedCriteriaEntries"
          class="col-7 ml-4"
          item-text="value"
          item-value="value"
          multiple
          return-object
          @change="ChangeCriteriaEntrySelection"
        />
      </div>

      <b-button
        :disabled="!isValid"
        variant="success"
        @click="SaveNewWageSupplementConfiguration"
      >
        Hinzufügen
      </b-button>
      <b-button
        class="ml-2"
        variant="danger"
        @click="hideModal('addNewWageSupplementConfiguration')"
      >
        Abbrechen
      </b-button>
    </b-modal>
  </div>
</template>

<script>
import { AddWageSupplementConfiguration } from "../../../../services/minimum.wage.services/zuschlagsrechner/supplementconfigurations";
import { MinimumWageMixin } from "@/components/minimum.wage/mixins/MinimumWageMixin";
import { GetPossibleStructureValues } from "@/services/minimum.wage.services/criteria.minimum.wages.js";

export default {
  mixins: [MinimumWageMixin],
  props: {
    languages: {
      type: Array,
      default: () => [],
    },
    canUserEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      errorObject: null,
      isLoading: true,
      criteriaOptions: [],
      selectedCriteria: null,
      criteriaEntryOptions: [],
      selectedCriteriaEntries: [],
      wageSupplementTitle: "",
      wageSupplementContentDe: "",
      wageSupplementContentFr: "",
      wageSupplementContentIt: "",
      rules: {
        required: (value) => !!value || "Feld ist erforderlich",
      },
    };
  },
  computed: {
    isValid() {
      let isValid = true;

      if (this.wageSupplementTitle === "") {
        isValid = false;
      }

      if (
        this.wageSupplementContentDe === "" &&
        this.languages.some((x) => x.language === "de-CH")
      ) {
        isValid = false;
      }

      if (
        this.wageSupplementContentFr === "" &&
        this.languages.some((x) => x.language === "fr-CH")
      ) {
        isValid = false;
      }

      if (
        this.wageSupplementContentIt === "" &&
        this.languages.some((x) => x.language === "it-CH")
      ) {
        isValid = false;
      }

      return isValid;
    },
  },
  watch: {
    "$store.state.mindestLohnKonfiguration.Criteria": function () {
      this.LoadRelevantCriterias();
    },
  },
  created() {
    this.LoadRelevantCriterias();
  },
  methods: {
    OpenModal() {
      this.wageSupplementTitle = "";
      this.wageSupplementContentDe = "";
      this.wageSupplementContentFr = "";
      this.wageSupplementContentIt = "";
      this.selectedCriteria = null;
      this.criteriaEntryOptions = [];
      this.selectedCriteriaEntries = [];
      this.showModal("addNewWageSupplementConfiguration");
    },
    ChangeWageSupplementTitle(newValue) {
      this.wageSupplementTitle = newValue;
    },
    LoadRelevantCriterias() {
      let itemsCopy = JSON.parse(
        JSON.stringify(this.$store.state.mindestLohnKonfiguration.Criteria),
      );
      this.criteriaOptions = itemsCopy.filter(
        (x) => x.listEntries && x.listEntries.length > 0,
      );
    },
    LoadOptionOfCriteria(newValue) {
      this.selectedCriteria = newValue;
      this.selectedCriteriaEntries = [];

      GetPossibleStructureValues(
        this.contractId,
        this.versionId,
        this.editionId,
        this.selectedCriteria.criteriaStructureId,
        [],
        true,
        false,
        (response) => {
          if (response) {
            this.criteriaEntryOptions = response;
            this.isLoading = false;
          }
        },
        (error) => {
          console.error(error);
        },
      );
    },
    ChangeCriteriaEntrySelection(newValue) {
      this.selectedCriteriaEntries = newValue;
    },
    SaveNewWageSupplementConfiguration() {
      this.isLoading = true;
      AddWageSupplementConfiguration(
        this.contractId,
        this.versionId,
        this.editionId,
        this.editionId,
        this.GetWageSupplementObject(),
        (response) => {
          if (response) {
            this.hideModal("addNewWageSupplementConfiguration");
            this.CreationSumbited(response);
          }
          this.isLoading = false;
        },
        (error) => {
          console.log(error);
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    GetWageSupplementObject() {
      let wageSupplementObject = {
        id: 0,
        configurationId: this.editionId,
        wageSupplementConfigurationTitle: this.wageSupplementTitle,
        wageSupplementConfigurationContents: [],
        criteriaListEntries: [],
        targetWorkingTime: {},
        maxWeeklyWorkingHours: {},
        overtimeRegulation_BillingAccordingDeployment: {},
        overtimeRegulation_BillingWeekly: {},
        overtimeRegulation_BillingOtherDefinition: {},
        overtimeRegulation_BillingNotSet: {},
        wageSupplementTypeDefinitions: [],
      };

      let langContents = [];

      if (this.wageSupplementContentDe) {
        langContents.push({
          id: 0,
          wageSupplementConfigurationId: wageSupplementObject.id,
          wageSupplementConfigurationDescription: this.wageSupplementContentDe,
          language: "de-CH",
        });
      }
      if (this.wageSupplementContentFr) {
        langContents.push({
          id: 0,
          wageSupplementConfigurationId: wageSupplementObject.id,
          wageSupplementConfigurationDescription: this.wageSupplementContentFr,
          language: "fr-CH",
        });
      }
      if (this.wageSupplementContentIt) {
        langContents.push({
          id: 0,
          wageSupplementConfigurationId: wageSupplementObject.id,
          wageSupplementConfigurationDescription: this.wageSupplementContentIt,
          language: "it-CH",
        });
      }

      wageSupplementObject.wageSupplementConfigurationContents = langContents;

      this.selectedCriteriaEntries.map((entry) => {
        wageSupplementObject.criteriaListEntries.push({
          id: 0,
          wageSupplementConfigurationId: 0,
          criteriaListEntryId: entry.criteriaListEntryId,
        });
      });

      return wageSupplementObject;
    },
    CreationSumbited(createdObject) {
      this.$emit("created", createdObject);
    },
    showModal(modalId) {
      this.$refs[modalId].show();
    },
    hideModal(modalRef) {
      if (this.$refs[modalRef]) {
        this.$refs[modalRef].hide();
      }
    },
  },
};
</script>

<style></style>
